import { Stack } from '@mui/material';
import { RocketAPI } from '@portal/rocket-api-client';
import { createFileRoute } from '@tanstack/react-router';

import { AccountInvitesTable } from 'component/partial/tables/users/AccountInvitesTable';
import { AccountUsersTable } from 'component/partial/tables/users/AccountUsersTable';

import { requireOperation } from './-guards';

export const Route = createFileRoute('/n/_auth/settings/_layout/users/')({
  beforeLoad: requireOperation({
    options: () => RocketAPI.accountUsers.getListAccountUsersQueryOptions(),
    redirectTo: '/n/settings/account-and-security',
  }),
  component: UsersRoute,
});

function UsersRoute() {
  return (
    <Stack sx={{ gap: 6 }}>
      <AccountUsersTable />
      <AccountInvitesTable />
    </Stack>
  );
}
